import React from 'react';
import { useIconThemed } from './use-icon-themed';
export default function DecisionMatrixIcon() {
  var _useIconThemed = useIconThemed(),
    iconThemed = _useIconThemed.iconThemed;
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_1296)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.759766",
    width: "39",
    height: "39",
    rx: "2.5",
    stroke: "var(--ds-border, #091E42)",
    strokeOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    })
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.2598C10.4087 22.2598 8.88258 21.6276 7.75736 20.5024C6.63214 19.3772 6 17.8511 6 16.2598C6 14.6685 6.63214 13.1423 7.75736 12.0171C8.88258 10.8919 10.4087 10.2598 12 10.2598C13.5913 10.2598 15.1174 10.8919 16.2426 12.0171C17.3679 13.1423 18 14.6685 18 16.2598C18 17.8511 17.3679 19.3772 16.2426 20.5024C15.1174 21.6276 13.5913 22.2598 12 22.2598ZM13.023 14.0368L11.409 17.1193L10.2517 16.0768C10.1785 16.0109 10.093 15.9601 10.0002 15.9272C9.90729 15.8943 9.80886 15.8801 9.71049 15.8853C9.61212 15.8905 9.51573 15.915 9.42683 15.9574C9.33793 15.9999 9.25827 16.0594 9.19238 16.1326C9.12648 16.2059 9.07566 16.2914 9.04281 16.3842C9.00996 16.4771 8.99572 16.5755 9.00091 16.6739C9.0061 16.7723 9.03061 16.8687 9.07305 16.9576C9.11549 17.0465 9.17502 17.1261 9.24825 17.192L11.1233 18.8795C11.2082 18.956 11.3095 19.0121 11.4195 19.0435C11.5294 19.0748 11.6451 19.0806 11.7576 19.0604C11.8701 19.0402 11.9766 18.9946 12.0687 18.927C12.1609 18.8593 12.2364 18.7715 12.2895 18.6703L14.352 14.7328C14.4443 14.5565 14.4628 14.3508 14.4034 14.161C14.3441 13.9711 14.2117 13.8126 14.0355 13.7203C13.8593 13.628 13.6536 13.6095 13.4637 13.6688C13.2738 13.7282 13.1153 13.8605 13.023 14.0368Z",
    fill: "var(--ds-background-accent-green-subtle, #4BCE97)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "26.2598",
    width: "12",
    height: "1",
    rx: "0.5",
    fill: "var(--ds-text-disabled, #A5ADBA)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "29.2598",
    width: "12",
    height: "1",
    rx: "0.5",
    fill: "var(--ds-text-disabled, #A5ADBA)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1137 16.2065L30.7052 14.6158C30.846 14.475 30.925 14.2842 30.925 14.0851C30.925 13.8861 30.846 13.6952 30.7052 13.5545C30.5645 13.4138 30.3736 13.3347 30.1746 13.3347C29.9756 13.3347 29.7847 13.4138 29.644 13.5545L28.054 15.146L26.4625 13.5545C26.3218 13.4139 26.1309 13.3349 25.932 13.335C25.733 13.3351 25.5423 13.4142 25.4016 13.5549C25.261 13.6956 25.182 13.8865 25.1821 14.0854C25.1822 14.2844 25.2613 14.4751 25.402 14.6158L26.992 16.2058L25.402 17.7973C25.2654 17.9387 25.1898 18.1282 25.1915 18.3248C25.1932 18.5215 25.2721 18.7096 25.4111 18.8486C25.5502 18.9877 25.7383 19.0666 25.9349 19.0683C26.1316 19.07 26.321 18.9944 26.4625 18.8578L28.0533 17.2678L29.644 18.8578C29.7136 18.9274 29.7963 18.9827 29.8873 19.0205C29.9783 19.0582 30.0758 19.0776 30.1744 19.0777C30.2729 19.0777 30.3704 19.0583 30.4615 19.0207C30.5525 18.983 30.6352 18.9278 30.7049 18.8581C30.7746 18.7885 30.8298 18.7058 30.8676 18.6148C30.9053 18.5238 30.9247 18.4263 30.9248 18.3278C30.9248 18.2293 30.9054 18.1317 30.8678 18.0407C30.8301 17.9497 30.7749 17.8669 30.7052 17.7973L29.1137 16.2065ZM28 22.2598C26.4087 22.2598 24.8826 21.6276 23.7574 20.5024C22.6321 19.3772 22 17.8511 22 16.2598C22 14.6685 22.6321 13.1423 23.7574 12.0171C24.8826 10.8919 26.4087 10.2598 28 10.2598C29.5913 10.2598 31.1174 10.8919 32.2426 12.0171C33.3679 13.1423 34 14.6685 34 16.2598C34 17.8511 33.3679 19.3772 32.2426 20.5024C31.1174 21.6276 29.5913 22.2598 28 22.2598Z",
    fill: "var(--ds-background-accent-red-subtler-pressed, #F87168)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "26.2598",
    width: "12",
    height: "1",
    rx: "0.5",
    fill: "var(--ds-text-disabled, #A5ADBA)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "29.2598",
    width: "12",
    height: "1",
    rx: "0.5",
    fill: "var(--ds-text-disabled, #A5ADBA)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    fill: "var(--ds-icon-inverse, #FFFFFF)",
    transform: "translate(0 0.259766)"
  }))));
}